<template>
  <br />
  <h4>Actualización de contraseña</h4>
  <hr />
  <br />
  <br />
  <br />
  <div class="container">
    <div class="container-fluid h-custom">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-md-9 col-lg-6 col-xl-5">
          <div class="row">
            <div class="col">
              <img
                src="../../assets/login.png"
                class="img-fluid"
                alt="Sample image"
              />
            </div>
            <div class="col">
              <h5>
                Ingrese una contraseña con las siguientes características:
              </h5>
              <ol>
                <li>Mínimo 8 caracteres</li>
                <li>...</li>
                <li>...</li>
                <li>...</li>
              </ol>
            </div>
          </div>
        </div>
        <div
          class="col-md-8 col-lg-6 col-xl-4 offset-xl-1"
          style="background-color: beige; padding: 20px"
        >
          <form>
            <FormulateInput
              type="email"
              name="email"
              label="Enter your email address"
              validation="email"
            />
            <!-- Email input -->
            <div class="form-outline mb-4">
              <input
                type="email"
                id="nombre"
                class="form-control form-control-lg"
                placeholder="Ingrese una dirección de correo válida"
                v-model="usuario.nombre"
                disabled
              />
              <label class="form-label" for="nombre"
                >Dirección de corrreo electrónico</label
              >
            </div>
            <!-- Password input -->
            <div class="form-outline mb-3">
              <input
                type="password"
                id="clave"
                class="form-control form-control-lg"
                placeholder="Ingrese una contraseña"
                v-model="usuario.clave"
              />
              <label class="form-label" for="clave">Contraseña</label>
            </div>
            <!-- Password input -->
            <div class="form-outline mb-3">
              <input
                type="password"
                id="clave"
                class="form-control form-control-lg"
                placeholder="Confirme su contraseña"
                v-model="usuario.claveConfirmacion"
              />
              <label class="form-label" for="clave">Confirmar Contraseña</label>
            </div>
            <div class="text-center text-lg-start mt-4 pt-2">
              <button
                type="button"
                class="btn btn-primary btn-lg"
                style="padding-left: 2.5rem; padding-right: 2.5rem"
                @click="actualizarUsuario()"
              >
                Actualizar
              </button>
            </div>
            <br />
          </form>
        </div>
        <p class="mensaje">{{ mensaje }}</p>
        <p class="mensaje">{{ mensaje02 }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  data() {
    return {
      usuario: {},
      mensaje: "",
      mensaje02: "",
    };
  },
  methods: {
    validateEmail() {
      // eslint-disable-next-line
      if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.usuario.nombre
        )
      )
        this.mensaje = "";
      else this.mensaje = "Dirección de correo electrónico inválida.";
    },
    async actualizarUsuario() {
      this.validateEmail();
      if (
        typeof this.usuario.clave === "undefined" ||
        this.usuario.clave === null
      ) {
        this.mensaje = "La clave no puede ser nula.";
        return;
      }
      if (this.usuario.clave.length < 8) {
        this.mensaje = "La clave debe tener mínimo 8 caracteres.";
        return;
      }
      if (this.usuario.clave !== this.usuario.claveConfirmacion) {
        this.mensaje = "La confirmación no coincide con la clave registrada.";
        return;
      }
      try {
        this.usuario.iprestador = 1;
        this.usuario.iprofesional = 1;
        await api.post("/registro", this.usuario);
        console.log(window.sessionStorage.getItem("registro_email"));
        console.log(window.sessionStorage.getItem("nombrePlan"));
        console.log(window.sessionStorage.getItem("registro_terminos"));

        this.$router.push("RegistroCompleto");
      } catch (error) {
        this.mensaje02 = error;
      }
    },
  },
  mounted() {
    this.usuario.nombre = window.sessionStorage.getItem("registro_email");
  },
};
</script>
<style>
.divider:after,
.divider:before {
  content: "";
  flex: 1;
  height: 1px;
  background: #eee;
}

.h-custom {
  height: calc(100% - 73px);
}

@media (max-width: 450px) {
  .h-custom {
    height: 100%;
  }
}

.mensaje {
  color: red;
  font-family: verdana;
  font-size: 12px;
  width: 100%;
}
</style>
